import { name } from '../symbols'
import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { TpaPageConfig } from '../types'
import type { TpaHandlerProvider } from '@wix/thunderbolt-symbols'
import { PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'

export type GetExternalIdResponse = Promise<string | undefined>

export const GetExternalIdHandler = withDependencies(
	[named(PageFeatureConfigSymbol, name)],
	({ widgets }: TpaPageConfig): TpaHandlerProvider => ({
		getTpaHandlers() {
			return {
				getExternalId(compId, msgData, { originCompId }): GetExternalIdResponse {
					return Promise.resolve(widgets[originCompId].externalId)
				},
			}
		},
	})
)
